// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__4u-5P","label":"LabeledBox_label__2yz9P"};